import styled, { css } from 'styled-components';
import { commonResets } from '../../Styles/Utils/commonResets.js';

const FormInputWrapper = styled.div.withConfig({
    displayName: "FormInput.styles__FormInputWrapper",
    componentId: "sc-f214a4d0-0"
})`
    ${commonResets}
    & *,
    &:before,
    &:after,
    & *:before,
    & *:after {
        ${commonResets}
    }

    width: 100%;
    height: 100%;
`;
const FormInputEye = styled.div.withConfig({
    displayName: "FormInput.styles__FormInputEye",
    componentId: "sc-f214a4d0-1"
})`
    position: absolute;
    z-index: 1;
    right: 0;
    top: 0;
    width: 60px;
    height: 60px;
    cursor: pointer;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-12738 1417.317 24.826 14.239'%3E%3Cdefs%3E%3Cstyle%3E .cls-1 %7B fill: %23fff; %7D %3C/style%3E%3C/defs%3E%3Cg id='Group_1956' data-name='Group 1956' transform='translate(-12738 1417.28)'%3E%3Cpath id='Path_1653' data-name='Path 1653' d='M0,7.138A33.528,33.528,0,0,1,5.146,2.624,18.816,18.816,0,0,1,8.531.8,10.72,10.72,0,0,1,16.34.751a20.918,20.918,0,0,1,8.486,6.522c-.858.812-1.715,1.67-2.6,2.46a17.961,17.961,0,0,1-5.936,3.814A11.667,11.667,0,0,1,5.349,12.013,37.31,37.31,0,0,1,0,7.138Zm7.448,0a4.977,4.977,0,1,0,9.953.045,4.978,4.978,0,1,0-9.953-.045Z' transform='translate(0 0)'/%3E%3Cpath id='Path_1654' data-name='Path 1654' class='cls-1' d='M33,14.155a4.966,4.966,0,1,1,4.965,5.078A5.019,5.019,0,0,1,33,14.155Zm7.967-.068a2.877,2.877,0,0,0-2.821-2.934,3.026,3.026,0,0,0-3.092,3.024,2.957,2.957,0,0,0,2.934,2.934A3.045,3.045,0,0,0,40.967,14.088Z' transform='translate(-25.552 -7.017)'/%3E%3Cpath id='Path_1655' data-name='Path 1655' d='M48.012,21.21a3.112,3.112,0,0,1-2.979,3.047A2.914,2.914,0,0,1,42.1,21.323,3,3,0,0,1,45.191,18.3,2.843,2.843,0,0,1,48.012,21.21Z' transform='translate(-32.597 -14.14)'/%3E%3C/g%3E%3C/svg%3E%0A");
    background-position: 100% 50%;
    background-size: 25px auto;
    background-repeat: no-repeat;
    transition: opacity 0.2s ease;
    opacity: 0.5;

    &:hover {
        opacity: 0.65;
    }

    ${(props)=>props.active && css`
            opacity: 1 !important;
        `}
`;

export { FormInputEye, FormInputWrapper };
